import s from './ButtonNew.module.scss';
import { clsx } from 'clsx';
import { ReactNode } from 'react';
import { IWithClassname } from '@/models/common';

interface Props extends IWithClassname {
  colorType?: 'primary' | 'secondary';
  icon?: ReactNode;
  text: string;
}

export const ButtonNew = ({ text, colorType = 'primary', icon, className }: Props) => {
  const classes = clsx(s.button, className, { [s[`button_${colorType}`]]: colorType });
  return (
    <button className={classes} type={'button'}>
      {icon && icon} {text}
    </button>
  );
};